import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src431700410/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to all .XXX registrations</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  These terms and conditions (the “Agreement”) supplement and are incorporated
  into the agreement between you and the ICANN Accredited Registrar
  (“Registrar”) that you use to Register or Reserve a name in the .XXX Top Level
  Domain (the “.XXX TLD”). As between you and ICM Registry, LLC (the “Registry”,
  “us”, “we”), in the event of any conflict between this Agreement and any of
  the terms of your agreement with Registrar (the “Registrar-Registrant
  Agreement”), this Agreement shall prevail.{' '}
    </p>
    <p>
  <strong>I. GENERAL TERMS AND CONDITIONS </strong>
    </p>
    <p>
  <strong>1.</strong> The Registry supports the protection of intellectual
  property. By applying to register or reserve a name in the .XXX TLD, you
  represent and warrant that neither your Registration nor your use of the name
  will infringe the intellectual property or other rights of any third
  party.{' '}
    </p>
    <p>
  <strong>2.</strong> You acknowledge and agree to abide by all Registry
  Policies set forth on the Registry Website. You specifically acknowledge and
  agree that the Registry Policies may be modified by the Registry, and agree to
  comply with any such changes in the time period specified for compliance.{' '}
    </p>
    <p>
  <strong>3.</strong> You agree to comply with applicable ICANN Requirements as
  set forth on the Registry Website.{' '}
    </p>
    <p>
  <strong>4.</strong> You represent and warrant that you have provided current,
  complete, and accurate information in connection with your Registration
  Request or Reservation Request, and that you will correct and update this
  information to ensure that it remains current, complete, and accurate
  throughout the term of any resulting Registration or Reservation. Your
  obligation to provide current, accurate, and complete information is a
  material element of this Agreement, and the Registry reserves the right to
  immediately deny, cancel, terminate, suspend, lock, or transfer any
  Registration or Reservation if it determines, in its sole discretion, that the
  information is materially inaccurate.{' '}
    </p>
    <p>
  <strong>5.</strong> You consent to the collection, use, processing, and/or
  disclosure of your personal information in the United States and in accordance
  with the Registry Privacy Policy posted on the Registry Website, and
  incorporated by reference here. If you are visiting the Registry Website from
  a country other than the country in which the Registry servers are located,
  your communications with the Registry may result in the transfer of
  information (including your membership account information) across
  international boundaries; you consent to such transfer.{' '}
    </p>
    <p>
  <strong>6.</strong> You agree to submit to proceedings commenced under ICANN's
  Uniform Domain Name Dispute Resolution Policy ("UDRP"), ICM’s Charter
  Eligibility Dispute Resolution Policy (“CEDRP”), and ICM’s Rapid Evaluation
  Service (“RES”), each as described on the Registry Website. You further agree
  to abide by the final outcome of any of those processes, subject to any appeal
  rights provided in those processes or the law, and you hereby release the
  Registry, its affiliates and service providers and/or IFFOR from any and all
  direct or indirect liability associated with such dispute resolution
  processes.{' '}
    </p>
    <p>
  <strong>7.</strong> You acknowledge and agree that the Registry reserves the
  right to disqualify you or your agents from making or maintaining any
  Registrations or Reservations in the .XXX TLD if you are found to have
  repeatedly engaged in abusive registrations, in its sole discretion.
    </p>
    <p>
  <strong>8.</strong> You acknowledge and agree that the Registry reserves the
  right to immediately deny, cancel, terminate, suspend, lock, or transfer any
  Reservation Request or Registration Request and any resulting Reservations or
  Registrations that it deems necessary, in its discretion, in furtherance of
  the following:{' '}
    </p>
    <blockquote>
  <p>
    a. to enforce Registry Policies and ICANN Requirements, as amended from time
    to time;{' '}
  </p>
  <p>
    b. to protect the integrity and stability of the Registry, its operations,
    and the .XXX TLD;{' '}
  </p>
  <p>
    c. to comply with any applicable law, regulation, holding, order, or
    decision issued by a court, administrative authority, or dispute resolution
    service provider with jurisdiction over the Registry or you;{' '}
  </p>
  <p>
    d. to establish, assert, or defend the legal rights of the Registry or a
    third party, or to avoid any liability, civil or criminal, on the part of
    the Registry as well as its affiliates, subsidiaries, owners, officers,
    directors, representatives, employees, contractors, and stockholders;{' '}
  </p>
  <p>
    e. to correct mistakes made by the Registry or any Registrar in connection
    with a Registration or Reservation; or{' '}
  </p>
  <p>f. as otherwise provided herein.</p>
    </blockquote>
    <p>
  <strong>9.</strong> You agree to indemnify to the maximum extent permitted by
  law, defend and hold harmless the Registry, its affiliates and service
  providers, and the International Foundation for Online Responsibility
  (“IFFOR”), and each of their respective directors, owners, officers,
  employees, contractors, and agents, from and against any and all claims,
  damages, liabilities, costs and expenses, including reasonable legal fees and
  expenses, arising out of or relating to your Registration or Reservation of,
  and/or your Registration Request or Registration Request for, any name in the
  .XXX TLD. You agree that the indemnifications stated herein survive
  termination of the Registrar-Registrant Agreement and this Agreement.{' '}
    </p>
    <p>
  <strong>10.</strong> This Agreement, its interpretation, and all disputes
  between the parties arising in any manner hereunder, shall be governed by and
  construed in accordance with the internal laws of the State of Florida,
  without giving effect to any choice or conflict of law provision or rule
  (whether of the State of Florida or any other jurisdiction). You agree and
  submit to the exercise of personal jurisdiction of courts in the State of
  Florida for the purpose of litigating any such claim or action.{' '}
    </p>
    <p>
  <strong>11.</strong> BY AGREEING TO THIS AGREEMENT, YOU ARE: (1) WAIVING
  CLAIMS THAT YOU MIGHT OTHERWISE HAVE AGAINST THE REGISTRY, ITS AFFILIATES AND
  SERVICE PROVIDERS, AND/OR IFFOR BASED ON THE LAWS OF OTHER JURISDICTIONS,
  INCLUDING YOUR OWN; (2) IRREVOCABLY CONSENTING TO THE EXCLUSIVE JURISDICTION
  OF, AND VENUE IN, STATE OR FEDERAL COURTS IN THE STATE OF FLORIDA OVER ANY
  DISPUTES OR CLAIMS YOU HAVE WITH THE REGISTRY, ITS AFFILIATES AND SERVICE
  PROVIDERS, AND/OR IFFOR; AND (3) SUBMITTING YOURSELF TO THE PERSONAL
  JURISDICTION OF COURTS LOCATED IN THE STATE OF FLORIDA FOR THE PURPOSE OF
  RESOLVING ANY SUCH DISPUTES OR CLAIMS. YOU FURTHER AGREE THAT ANY CAUSE OF
  ACTION ARISING OUT OF OR RELATED TO OUR SERVICES MUST COMMENCE WITHIN ONE (1)
  YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS
  PERMANENTLY BARRED.{' '}
    </p>
    <p>
  <strong>12.</strong> You acknowledge and agree that the Registry is and shall
  be an intended third party beneficiary of the obligations you undertake in
  this Agreement. You acknowledge and agree that the Registry’s third party
  beneficiary rights have vested, and shall survive any termination or
  expiration of your Registration or Reservation.{' '}
    </p>
    <p>
  <strong>13.</strong> You acknowledge and agree that names in the .XXX TLD are
  provided "as is", "with all faults" and "as available." The Registry, its
  affiliates and service providers, and IFFOR make no express warranties or
  guarantees about such names.{' '}
    </p>
    <p>
  <strong>14.</strong> TO THE GREATEST EXTENT PERMITTED BY LAW, THE REGISTRY,
  ITS AFFILIATES AND SERVICE PROVIDERS, AND IFFOR DISCLAIM IMPLIED WARRANTIES
  THAT THE .XXX TLD AND ALL SOFTWARE, CONTENT AND SERVICES DISTRIBUTED THROUGH
  THE REGISTRY, ITS AFFILIATES AND SERVICE PROVIDERS AND/OR IFFOR ARE
  MERCHANTABLE, OF SATISFACTORY QUALITY, ACCURATE, TIMELY, FIT FOR A PARTICULAR
  PURPOSE OR NEED, OR NON-INFRINGING. THE REGISTRY, ITS AFFILIATES AND SERVICE
  PROVIDERS AND/OR IFFOR DO NOT GUARANTEE THAT ANY NAME IN THE .XXX TLD, IFFOR
  SERVICES, OR REGISTRY OPERATIONS WILL MEET YOUR REQUIREMENTS, WILL BE
  ERROR-FREE, RELIABLE, WITHOUT INTERRUPTION OR AVAILABLE AT ALL TIMES. WE DO
  NOT GUARANTEE THAT THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE .XXX
  TLD, INCLUDING ANY SUPPORT SERVICES, WILL BE EFFECTIVE, RELIABLE, ACCURATE OR
  MEET YOUR REQUIREMENTS. WE DO NOT GUARANTEE THAT YOU OR THIRD PARTIES WILL BE
  ABLE TO ACCESS OR USE ANY NAME IN THE .XXX TLD (EITHER DIRECTLY OR THROUGH
  THIRD-PARTY NETWORKS) AT TIMES OR LOCATIONS OF YOUR CHOOSING. NO ORAL OR
  WRITTEN INFORMATION OR ADVICE GIVEN BY A REPRESENTATIVE OF THE REGISTRY, ITS
  AFFILIATES AND SERVICE PROVIDERS, AND/OR IFFOR SHALL CREATE A WARRANTY
  REGARDING OPERATIONS OF THE REGISTRY OR ANY NAME IN THE .XXX TLD.{' '}
    </p>
    <p>
  <strong>15.</strong> THE REGISTRY, ITS AFFILIATES AND SERVICE PROVIDERS,
  AND/OR IFFOR SHALL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL,
  CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING FROM YOUR USE OF, INABILITY TO USE,
  OR RELIANCE UPON A NAME IN THE .XXX TLD. THESE EXCLUSIONS APPLY TO ANY CLAIMS
  FOR LOST PROFITS, LOST DATA, LOSS OF GOODWILL, WORK STOPPAGE, COMPUTER FAILURE
  OR MALFUNCTION, OR ANY OTHER COMMERCIAL DAMAGES OR LOSSES, EVEN IF THE
  REGISTRY, ITS AFFILIATES AND SERVICES PROVIDERS AND/OR IFFOR KNEW OR SHOULD
  HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES. BECAUSE SOME STATES OR
  JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR THE LIMITATION OF LIABILITY FOR
  CONSEQUENTIAL OR INCIDENTAL DAMAGES, IN SUCH STATES OR JURISDICTIONS, THE
  REGISTRY’S LIABILITY, AND THE LIABILITY OF THE REGISTRY’S AFFILIATES AND
  SERVICE PROVIDERS, AND/OR IFFOR SHALL BE LIMITED TO THE MAXIUMUM EXTENT
  PERMITTED BY LAW. YOU FURTHER AGREE THAT IN NO EVENT SHALL THE REGISTRY’S, ITS
  AFFILIATES AND SERVICE PROVIDERS, AND/OR IFFOR’S TOTAL AGGREGATE LIABILITY
  EXCEED THE TOTAL AMOUNT PAID BY YOU FOR THE PARTICULAR PRODUCTS OR SERVICES
  THAT ARE THE SUBJECT OF THE CAUSE OF ACTION. YOU AGREE THAT THE RIGHTS STATED
  HEREIN SURVIVE TERMINATION OF THE REGISTRAR- REGISTRANT AGREEMENT AND THIS
  AGREEMENT. You may have additional consumer rights under your local laws that
  this Agreement cannot change.{' '}
    </p>
    <p>
  <strong>16.</strong> The Registry reserves the right to modify, change, or
  discontinue any aspect of its services, agreements, this Agreement, including
  without limitation its prices and fees. You acknowledge and agree that the
  Registry, its affiliates and service providers, and/or IFFOR may provide any
  and all required notices, agreements, modifications and changes to this
  Agreement, and other information concerning the .XXX TLD electronically, by
  posting such items on the Registry Website. Your continued use of the Registry
  Website or your Registration and/or Reservation of any name in the .XXX TLD
  shall constitute your acceptance of the most current versions of those
  notices, agreements, modifications, and changes to this Agreement. In the
  event of any conflict between this Agreement and the notices, agreements,
  modifications or changes to this Agreement as posted from time to time on the
  Registry Website, the then-current terms of this Agreement posted on the
  Registry Website shall prevail.{' '}
    </p>
    <p>
  <strong>17.</strong> You represent and warrant that your use of the Registry
  and/or any name in the .XXX TLD will not be for any illegal purposes,
  including without limitation:
    </p>
    <blockquote>
  <p>
    a. any purposes that promote or encourage the promotion of child pornography
    or the exploitation of minors in any way;{' '}
  </p>
  <p>
    b. the infringement of the intellectual property rights of any other person
    or entity;{' '}
  </p>
  <p>
    c. the impersonation of any person or entity, or the submission of
    information on behalf of any other person or entity, without their express
    prior written consent;{' '}
  </p>
  <p>
    d. the violation of privacy or publicity rights of any other person or
    entity;{' '}
  </p>
  <p>
    e. the promotion or engagement in any spam or other unsolicited bulk email,
    or computer or network hacking or cracking; or{' '}
  </p>
  <p>
    f. the interference with the operation of the Registry Website or services
    offered by the Registry and/or IFFOR.{' '}
  </p>
    </blockquote>
    <p>
  <strong>18.</strong> Names in the .XXX TLD are intended for and available to
  Applicants and Registrants who are at least eighteen (18) years of age. By
  submitting a Registration Request, creating a Registration, or maintaining a
  Registration you represent and warrant that you are at least eighteen (18)
  years of age.{' '}
    </p>
    <p>
  <strong>19.</strong> If you are entering into this Agreement on behalf of a
  corporate entity, you represent and warrant that you have the legal authority
  to bind such corporate entity to the terms and conditions contained in this
  Agreement, in which case the terms “you”, “your”, Applicant, or Registrant
  shall refer to such corporate entity. If, after your electronic acceptance of
  this Agreement, the Registry finds that you do not have the legal authority to
  bind such corporate entity, you will be personally responsible for the
  obligations contained in this Agreement, including but not limited to the
  payment obligations. The Registry shall not be liable for any loss or damage
  resulting from the Registry’s reliance on any instruction, notice, document,
  or communication reasonably believed by the Registry to be genuine and
  originating from an authorized representative of your corporate entity. If
  there is reasonable doubt about the authenticity of any such instruction,
  notice, document, or communication, the Registry reserves the right (but
  undertakes no duty) to require additional authentication from you.{' '}
    </p>
    <p>
  <strong>20.</strong> Registry Website may contain links to third party
  websites that are not owned or controlled by the Registry. The Registry
  assumes no responsibility for the content, terms and conditions, privacy
  policies, or practices of any third party websites, including without
  limitation its service providers or dispute resolution providers.{' '}
    </p>
    <p>
  <strong>
    II. ADDITIONAL TERMS FOR ALL SUNRISE APPLICANTS AND ALL LANDRUSH
    APPLICANTS{' '}
  </strong>
    </p>
    <p>
  <strong>1.</strong> At the close of the Sunrise period, if more than one
  Sunrise application of any kind (AT, AD, or B) is made for a domain name, all
  Sunrise Applicants for that name will be notified of the claims made by the
  other Sunrise Applicants for that name and that name will proceed to auction,
  in accordance with the Auction Rules. You agree to be bound by the Auction
  Rules. In furtherance of this provision, by submitting a Sunrise application
  you agree that the Registry and/or its Validation Agent is authorized to share
  information relating to your Sunrise application with other Sunrise
  Applicants. In the event any Sunrise Applicant proceeds with a Registration,
  such Applicant will be deemed on notice of the intellectual property claims
  submitted by the other Sunrise Applicant(s) and may not claim lack of notice
  with regard to such Applicant(s) in any subsequent dispute proceeding. You
  acknowledge and agree that you may not use proxy services during the Sunrise
  period.{' '}
    </p>
    <p>
  <strong>2.</strong> At the close of the Landrush period, if more than one
  Landrush application is made for a domain name, all Landrush applicants will
  be notified that the domain name will proceed to auction, in accordance with
  Auction Rules. You agree to be bound by the Auction Rules.{' '}
    </p>
    <p>
  <strong>
    III. ADDITIONAL TERMS FOR SUNRISE B (NON-COMMUNITY TRADEMARK)
    APPLICANTS{' '}
  </strong>
    </p>
    <p>
  <strong>1.</strong> If you have submitted a Reservation Request under the
  Registry’s Sunrise B procedure, you acknowledge and agree that if your
  application is successful, your Reservation will not result in a Registration,
  does not convey any additional rights, including without limitation any
  additional intellectual property rights, and queries will resolve to a
  standard page that indicates that the name is reserved. You further
  acknowledge and agree that you may not in the future elect to convert this
  Reservation to a resolving Registration.{' '}
    </p>
    <p>
  <strong>2.</strong> You acknowledge and agree that the Registry, its
  affiliates and service providers, and IFFOR shall have no liability of any
  kind for any direct or indirect loss or liability resulting from or arising in
  connection with the Sunrise processes, including, without limitation: (a) your
  ability or inability to reserve a name in the .XXX TLD through this process,
  and (b) any dispute between any parties arising in connection with this
  process. IV. ADDITIONAL TERMS FOR REGISTRANTS OF NON-RESOLVING NAMES By
  applying to register a non-resolving name in .XXX TLD you acknowledge and
  agree that if your application is successful, your Registration will not
  resolve in the DNS. You further acknowledge and agree that you may not in the
  future elect to convert this Registration to a resolving Registration unless
  you subsequently qualify for membership in the Sponsored Community, complete
  the Membership Application Process on the Registry Website, and receive
  Membership Credentials that you provide to your Registrar. V. ADDITIONAL TERMS
  FOR MEMBERS OF THE SPONSORED COMMUNITY AND PROXY SERVICES 1. By applying to
  register a resolving name in the .XXX TLD, you represent and warrant that you
  are a member of the Sponsored Community or a Registry-approved proxy service
  acting on behalf of a member of the Sponsored Community. 2. In order to
  participate in the Registry’s Sunrise A or Landrush procedures, you
  acknowledge and agree that you must complete the Membership Application
  Process on the Registry Website within forty eight (48) hours after the close
  of either Sunrise or Landrush, as applicable to you. You further acknowledge
  and agree that if you do not complete the Membership Application Process
  within the above-referenced time frame, your request for a name in the .XXX
  TLD during the Sunrise A or Landrush procedures shall be deemed invalid.{' '}
    </p>
    <p>
  <strong>3.</strong> If you are a member of the Sponsored Community, you
  represent and warrant that you have provided or will provide current, accurate
  and complete information in connection with the Membership Application
  Process, and will keep that information current. You understand that your
  Registration will not resolve unless and until you supply your Registrar with
  the Membership Credentials you received upon completing the Membership
  Application Process on the Registry Website.{' '}
    </p>
    <p>
  <strong>4.</strong> If you are a Registry-authorized proxy service, you
  represent and warrant that (i) you have authenticated the member of the
  Sponsored Community that has provided or will provide the Membership
  Credentials in connection with the Registration, and (ii) you will comply with
  the most current version of the proxy service standards posted on the Registry
  Website.{' '}
    </p>
    <p>
  <strong>5.</strong> You acknowledge and agree that Registry, its affiliates
  and service providers, and IFFOR shall have no liability of any kind for any
  direct or indirect loss or liability resulting from the proceedings and
  processes relating to the Sunrise Process, the Landrush process, General
  Availability period, or any process the Registry uses for allocating Premium
  Names or other names in the .XXX TLD, including without limitation: (a) the
  ability or inability of a Registrant to obtain a name in the .XXX TLD during
  these periods, and (b) any dispute, amongst any parties, arising in connection
  with any of those processes.{' '}
    </p>
    <p>
  <strong>6.</strong> You acknowledge and agree that the content of websites in
  the .XXX TLD may not be appropriate, legal, and or available for use in all
  locations, and hosting the name in territories where such content is illegal
  is prohibited. If you choose to register and/or operate the name from a
  location outside the U.S., you do so on your own initiative. In all cases, you
  are responsible for compliance with local laws.{' '}
    </p>
    <p>
  <strong>
    VI. ADDITIONAL TERMS APPLICABLE TO FOUNDERS PROGRAM AND PREMIUM NAME HOLDERS
  </strong>
    </p>
    <p>
  You acknowledge and agree that if the name you are seeking to register is a
  Premium Name, as determined by the Registry in its sole discretion, then use
  of the name is also subject to the terms and conditions of a separate
  agreement between you and the Registry, and that your rights in any such names
  are governed by the terms of that separate agreement.{' '}
    </p>
    <p>
  <strong>VII. DEFINITIONS</strong>
    </p>
    <p>
  <strong>Accredited Registrar</strong> is a domain name registrar that is (i)
  accredited by ICANN and (ii) has entered into a Registry-Registrar Agreement
  with the Registry.{' '}
    </p>
    <p>
  <strong>Adult-Entertainment</strong> is intended to be understood broadly for
  a global medium, to include those websites that convey Online Adult
  Entertainment, operated by webmasters who have voluntarily determined that a
  system of self-identification would be beneficial.{' '}
    </p>
    <p>
  <strong>Applicant</strong> is a natural person, company, or organization in
  whose name a Registration Request or a Reservation Request is made.{' '}
    </p>
    <p>
  <strong>Auction Provider</strong> for the Sunrise and Landrush programs is
  Pool.com, Inc.{' '}
    </p>
    <p>
  <strong>Auction Rules</strong> are the terms and conditions published by the
  Auction Provider on the Registry Website.{' '}
    </p>
    <p>
  <strong>ICANN Requirements</strong> include the Registry’s obligations under
  the Registry Agreement between ICM and ICANN dated 31 March 2011, all ICANN
  Consensus Policies applicable to the .XXX TLD, and all applicable ICANN
  Temporary and Specifications and Policies, each as defined in the Registry
  Agreement.{' '}
    </p>
    <p>
  <strong>Membership Application</strong> Process must be completed by
  Applicants for resolving Registrations in order to: (i) confirm their status
  as a member of the Sponsored Community; (ii) confirm contact information; and
  (iii) acquire Membership Credentials. No Registrations in the .XXX TLD will
  resolve until the Membership process has been successfully completed.{' '}
    </p>
    <p>
  <strong>Membership Credentials</strong> consist of a membership token and such
  other criteria as may be determined by the Registry from time to time.{' '}
    </p>
    <p>
  <strong>Premium Name</strong> is a name that has been reserved by the Registry
  in its sole discretion, which may be offered for registration to members of
  the Sponsored Community on other than a first-come first-served basis.{' '}
    </p>
    <p>
  <strong>Registrant</strong> is an Applicant that has submitted a Registration
  Request that has been paid for in full and accepted by the Registry. A
  Registrant is the holder of a registered name in the .XXX TLD.{' '}
    </p>
    <p>
  <strong>Registration</strong> means a name in the .XXX TLD submitted by a
  Registrar on behalf of a member of the Sponsored Community or non-member of
  the Sponsored Community, in the case of non-resolving name Registration
  Requests during the period of General Availability, for a specified Term that
  has been accepted by the Registry in accordance with the terms of the
  Registry-Registrar Agreement and the Registry-Registrant Agreement.{' '}
    </p>
    <p>
  <strong>Registration Request</strong> is an application submitted by an
  Accredited Registrar on behalf of a member of the Sponsored Community or an
  approved proxy service for a member of the Sponsored Community, or non-member
  of the Sponsored Community, in the case of non-resolving name Registration
  Requests during the period of General Availability, to register a name in the
  .XXX TLD. Registration Requests are non-transferable. Registry is ICM
  Registry, LLC.{' '}
    </p>
    <p>
  <strong>Registry Policies</strong> means the policies adopted from time to
  time by the Registry as posted under Policies on the Registry Website,
  including without limitation the Launch Plan and Related Policies.{' '}
    </p>
    <p>
  <strong>Registry-Registrant</strong> Agreement is the Registry-Registrant
  Agreement Schedule and/or Registry-Registrant Agreement, as amended from time
  to time and posted on the Registry Website.{' '}
    </p>
    <p>
  <strong>Registry-Registrar</strong> Agreement is the agreement between the
  Registry and Accredited Registrars, as amended from time to time. Registry
  Website is www.icmregistry.com.{' '}
    </p>
    <p>
  <strong>Reservation</strong> means the reservation from registration of a name
  in the .XXX TLD submitted by a Registrar on behalf of an entity or individual
  that is not a member of the Sponsored Community that has been accepted by the
  Registry in accordance with the terms of the Registry-Registrar Agreement and
  the Registry-Registrant Agreement.{' '}
    </p>
    <p>
  <strong>Reservation</strong> Request is a request submitted by an Accredited
  Registrar on behalf of an Applicant who is not a member of the Sponsored
  Community but who desires to reserve from registration names that correspond
  to their registered trademark. Names that are the subject of successful
  Reservation Requests will resolve to standard pages that indicate that the
  name is not available for registration in the sTLD. Reservation Requests are
  non-transferable.{' '}
    </p>
    <p>
  <strong>Sponsored Community</strong> consists of individuals, business,
  entities, and organizations that: (i) have voluntarily determined that a
  system of self-identification would be beneficial, (ii) have voluntarily
  agreed to comply with all IFFOR Policies and Best Practices Guidelines, as
  published from time to time on the IFFOR web site; and (iii) either: - Provide
  Online Adult Entertainment intended for consenting adults (“Providers”); -
  Represent Providers (“Representatives”); or - Provide products or services to
  Providers and Representatives (“Service Providers”).{' '}
    </p>
    <p>
  <strong>Validation Agent</strong> means IPRota, Ltd., who has contracted with
  the Registry to conduct validation processes stated herein.
    </p>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      